// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartWrapper_wrapper__EEBCu","headerWrapper":"ChartWrapper_headerWrapper__m5bmd","icon":"ChartWrapper_icon__34V7X","chartWrapper":"ChartWrapper_chartWrapper__mdY5q"};